import { render } from "./VRInfo.vue?vue&type=template&id=62b0fe96"
import script from "./VRInfo.vue?vue&type=script&lang=js"
export * from "./VRInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__